// extracted by mini-css-extract-plugin
export default {"default":"BulletList_default__ucRt2","small":"BulletList_small__KiW3J"};